<template>
  <v-layout row>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" :color="currentStatusItem.color">
          {{ currentStatusItem.icon }}
        </v-icon>
      </template>
      <span>{{ currentStatusItem.tooltipText }}</span>
    </v-tooltip>

    <v-tooltip right v-if="delayed">
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" color="error">
          priority_high
        </v-icon>
      </template>
      <span>{{ $t("DelayedAdjective") }}</span>
    </v-tooltip>
  </v-layout>
</template>

<script>
export default {
  name: "ActivityTaskStatusIcon",

  props: {
    status: {
      type: String,
      required: true
    },

    delayed: {
      type: Boolean
    }
  },

  data() {
    return {};
  },

  computed: {
    statuses() {
      return [
        {
          code: "closed",
          color: "success",
          icon: "check_circle",
          tooltipText: this.$i18n.tc("ClosedNoun", 1)
        },
        {
          code: "issues",
          color: "error",
          icon: "check_circle",
          tooltipText: this.$i18n.tc("Issue", 2)
        },
        {
          code: "in_progress",
          color: "warning",
          icon: "check_circle",
          tooltipText: this.$i18n.t("InProgress")
        },
        {
          code: "scheduled",
          color: "accent",
          icon: "check_circle",
          tooltipText: this.$i18n.t("ScheduledAdjective")
        },
        {
          code: "created",
          color: "",
          icon: "check_circle",
          tooltipText: this.$i18n.t("CreatedAdjective")
        },
        {
          code: "assigned",
          color: "accent",
          icon: "check_circle",
          tooltipText: this.$i18n.t("Assigned")
        },
        {
          code: "completed",
          color: "success",
          icon: "check_circle",
          tooltipText: this.$i18n.t("Completed")
        },
        {
          code: "pending_approval",
          color: "light-green lighten-3",
          icon: "check_circle",
          tooltipText: this.$i18n.t("PendingApproval")
        }
      ];
    },

    currentStatusItem() {
      return this.statuses.find(status => status.code === this.status);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FieldManagement/StatusIcon.vue